import $ from 'jquery';
import ampSearchDrawer from "./amp-search-drawer";
import ampOpenMenu from "./amp-open-menu";
import ampCategoryMenu from "./amp-category-menu";
import toggleVisibility from 'modules/toggle-visibility';
import headerLogout from "./header-logout";
import logout from "modules/logout";
import search from "modules/search";
import revolveMePopup from "modules/revolve-me-popup";
import heartProduct from "modules/heart-product";
import loadFavoriteCount from "./load-favorite-count";
import loadShoppingBagCount from "./load-shopping-bag-count";
import 'modules/page-constrain';
import 'modules/fixed-overlay';
import 'styleguide/modules/slick-carousel';
import zipCodeValidate from 'modules/validate-zip-code';

function fixedOverlay(){
  $('.js-fixed-overlay').fixedOverlay();
}

function categoryNav() {
    var $pageHeaderOverlay = $(".js-page-header-categories-overlay");
    var $pageHeaderTitle = $("#nav-categories");


    $pageHeaderOverlay.on("click", function() {
      $pageHeaderTitle.click();
    });
}

function clickToLogoutFromHeader() {
  headerLogout('#js-header-logout');
}

function toggleRevolveMenu() {
  $('#tr-burger-icon').on('click', function(e) {
    e.preventDefault();
    toggleVisibility('js-top-navigation');
  });
}

// function clearSearchCookiesFromHeader() {
//   clearSearchCookies('#mens-homepage-search-button');
// }

function initSearch() {
    $('#tr_top_search_btn, #js-site-search-close').on('click', function(e) {
      e.preventDefault();
      toggleVisibility('js-site-search');
    });
    $(".js-site-search__textbox").removeClass('site-search__textbox--preload');
    search.init();
  // return new Search('#search_term');
}
function loadFavPopups() {
    var $favoritePopupDiv = $("#myFavLimitPopupWrapper");

    if ($favoritePopupDiv.length) {
        $.ajax({
            type: 'GET',
            url: '/content/favorites/fav-max-popup-markup',
            success: function (data) {
                $favoritePopupDiv.empty().append(data);
            },
            failure: function () {
            }
        });
    }
}
// function initMobileMenu() {
//   var siteMenuContainerEl = document.getElementById('site-menu-container');
//   if (siteMenuContainerEl) {
//     return new SiteMenu(
//       siteMenuContainerEl,
//       document.getElementById('logo_drop_down_mhp'),
//       document.getElementById('site-menu')
//     );
//   } else {
//     console.error('no #site-menu-container could be found');
//   }
// }


function toggleFeaturedShopsMenu() {
    $('#js-featured-menu-button').on('click', function(e) {
        e.preventDefault();
        $(this).toggleClass('is-active');
        toggleVisibility('featured-shops-list');
    });
}

function validateZipCode(selector){
    return zipCodeValidate(selector);
}

window.initMobileHp = function(){
    window.resetLazyLoad();
    // setupHomeSlideshow();
    toggleFeaturedShopsMenu();
    revolveMePopup();
    $('.js-lazyload-image').lazyLoadImage();
    $('.js-featured-slides').slick({
        arrows: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1.5,
        slidesToScroll: 1,
        lazyLoad: 'progressive',
        accessibility: false,
    });
    $('.js-toggle-display').toggleDisplay();
    $('.js-category-menu').categoryMenu();
}

function initMobileSiteHeader(){
  loadFavoriteCount.then((data) => {
    var favoritesTotal = data.total > 99 ? "99+" : data.total;
    $('#tr_top_heart_mhp_count').empty().append(favoritesTotal);
    $('#tr_top_heart_mhp_count').attr('data-count', data.total);
    if (data.total === 0) {
      $('.fav-count--ab').hide();
    } else {
      $('.fav-count--ab').show();
    }
    var labelText=$('#tr_top_heart_mhp').attr('aria-label');
    if (typeof(labelText) !== 'undefined') {
        $('#tr_top_heart_mhp').attr('aria-label', labelText.replace('{0}', data.total));
    }
  })
  loadShoppingBagCount.then((data) => {
    $('#shopping_bag_count').empty().append(data.itemCount);
    if (data.itemCount === 0) {
      $('.bag-count--ab').hide();
    } else {
      $('.bag-count--ab').show();
    }
    var labelText=$('#tr_top_bag_mhp').attr('aria-label');
    if (typeof(labelText) !== 'undefined') {
        $('#tr_top_bag_mhp').attr('aria-label', labelText.replace('{0}', data.itemCount));
    }
  });
}

$(document).ready(function() {
  clickToLogoutFromHeader();
  initSearch();
  initMobileSiteHeader();
  toggleRevolveMenu();
  //toggleDisplay();
  categoryNav();
  fixedOverlay();
  loadFavPopups();
  ampCategoryMenu();
  ampSearchDrawer();
  ampOpenMenu();
  window.headerLogOut = logout;

  if($('#tryonlpProducts').length) {
      heartProduct('#tryonlpProducts', '.fav-item');
  }

  // clearSearchCookiesFromHeader();
  // initMobileMenu();
  window.validateZipCode = validateZipCode;
  window.submitHeart = function(paramtype, paramvalue, action, psize, sectionUrl){
      //this method is used by /r/dialog/ShoppingBagLimit.jsp
      heartProduct.submitHeart(paramtype, paramvalue, action, psize, sectionUrl, function () {
          var favBtnOnPDP = $('.js-fav-button');
          if(favBtnOnPDP.length > 0 && !favBtnOnPDP.hasClass('favorite-button--active')){
              favBtnOnPDP.addClass('favorite-button--active');
          }

          if(window.rcProps && typeof window.rcProps.ReCAPTCHARestore =='function'){
              window.rcProps.ReCAPTCHARestore();
              window.rcProps.ReCAPTCHARestore = "";
          }
          if($('#move-to-fav-notification-modal').length > 0){
              $.ajax({
                  type: 'GET',
                  url: '/content/favorites/moveToFav',
                  success: function (data) {
                      $('body').append(data);
                      $.modal({triggerOpen:true, open: "move-to-fav-notification-modal"});
                  },
                  failure: function () {
                  }
              });

          }else{
              $.modal.close();
          }
      });
  };
    $(".js-close-banner").click(function () {
        $.post("/r/ajax/SetRevolveSessionParam.jsp", $.param({
            "key": "rglobalbannerdismiss",
            "value": "disableglobalbanner"
        }), function () {});
    });
    $('#iphoneRestrictionsAnchor').click(function(e) {
        e.preventDefault();
        $.modal({
            url: "/content/favorites/mobile/appRestrictionPopup",
            type: "toast",
            triggerOpen: true,
            returnFocus: "#iphoneRestrictionsAnchor"
        });
    });

});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/header/index.js